import styled from 'styled-components';
import * as Component from '~components';

export const Container = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.km12};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column-reverse;
    margin-top: 72px;
  }
`;

export const ColumnContent = styled(Component.Column)`
  flex: 1;

  :last-of-type {
    align-items: end;
    justify-content: end;
  }
`;

export const IllustrationColumn = styled(ColumnContent)`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: none;
  }
`;

export const Title = styled(Component.Text)`
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: 32px;
  letter-spacing: -0.03em;

  :first-of-type {
    font-size: 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    font-size: ${({ theme }) => theme.font.size.m7};

    :first-of-type {
      margin-top: ${({ theme }) => theme.spacing.km10};
    }
  }
`;

export const SubTitle = styled(Component.Text)`
  font-size: ${({ theme }) => theme.font.size.m5};
`;

export const Card = styled(Component.Column)`
  margin-top: ${({ theme }) => theme.spacing.km8};
  padding: ${({ theme }) => theme.spacing.km8};
  border-radius: 12px;
  border: ${({ theme }) => theme.border.width.thinner}
    ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.color.border.neutral.default};

  max-width: 375px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    max-width: 100%;
  }
`;

export const TextBank = styled(Component.Text)`
  margin-top: ${({ theme }) => theme.spacing.km8};
`;

export const TextCardData = styled(Component.Text).attrs({
  color: 'neutral-strong',
})`
  font-size: ${({ theme }) => theme.font.size.m4};
  font-weight: ${({ theme }) => theme.font.weight.bold};

  :first-of-type {
    margin-right: ${({ theme }) => theme.spacing.km2};
  }
`;

export const RowCardData = styled(Component.Row)`
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing.km6};
`;

export const Tooltip = styled(Component.Tooltip)`
  display: flex;
  align-items: center;
`;
